import { Box, Tab, Tabs } from "@mui/material";
import * as React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useLanguage } from "../../Language";
import { useLocationConfiguration } from "../../LocationConfiguration";

export const AdvancedSearchPage: React.FC = () => {
  const { translate } = useLanguage();
  const location = useLocation();
  const { locationConfiguration: { pacSettings } = { pacSettings: null } } =
    useLocationConfiguration();
  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        width="100%"
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        <Tabs
          value={location.pathname}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="scrollable auto tabs example"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          <Tab
            value="/advanced-search/boolean"
            component={Link}
            to="boolean"
            label={translate("booleanSearch")}
          ></Tab>
          {(pacSettings?.acceleratedReaderEnabled ||
            pacSettings?.lexileEnabled) && (
            <Tab
              value="/advanced-search/reading-levels"
              component={Link}
              to="reading-levels"
              label={translate("readingLevels")}
            ></Tab>
          )}
          {pacSettings?.reservesEnabled && (
            <Tab
              value="/advanced-search/reserves"
              component={Link}
              to="reserves"
              label={translate("academicReserves")}
            ></Tab>
          )}
        </Tabs>
      </Box>
      <Box padding={2}>
        <Outlet></Outlet>
      </Box>
    </>
  );
};
